import NavigationShell from './NavigationShell';
import { makePrintSensitive } from 'src/components/higherOrder/Print/PrintSenstive';
import type { AppThunkDispatch } from 'src/store.types';
import type { AppState } from 'src/reducers';
import { BoundEnabledPerspective, Perspective } from 'configuration-schemas/bindings.types';
import {
  setActivePerspective,
  setActiveTab,
  preSetActiveSubPage,
  setActiveSubPage,
  preSetActivePage,
  setViewLinks,
  setRedirectOnScopeExpired,
  setActivePageAndComponentProps,
} from 'src/pages/NavigationShell/NavigationShell.slice';
import { connect } from 'react-redux';
import {
  setSessionPerspective,
  setSessionPage,
  setSessionTab,
  setSessionSubPage,
} from 'src/components/RestoreSession/RestoreSession.utils';
import { RouteLink } from 'src/types/RouteLink';
import { withRouter } from 'src/components/higherOrder/withRouter';
import { updateAppConfig } from 'src/services/configuration/AppConfig.slice';
import { getPerspectiveLookupKey } from 'src/services/configuration/service.utils';
import { appReady } from 'src/state/ViewConfig/ViewConfig.slice';
import { getScopeId, isReady } from 'src/state/scope/Scope.types';
import { MfpGetScopeRequest, getScope } from 'src/state/scope/Scope.actions';
import { get, isEmpty } from 'lodash';
import { clearScope } from 'src/state/scope/Scope.slice';
import { DispatchProps, StateProps } from './NavigationShell.types';

function mapStateToProps(state: AppState): StateProps {
  const isFetchingMfpScope = get(state.mfpScope, 'isFetching', false);
  const isNewScope = get(state.mfpScope, '_newScope', false);

  return {
    validScope: state.scope.scope.valid || isReady(state.mfpScope),
    activeTab: state.perspective.activeTab,
    tenantConfig: state.appConfig.tenantConfig,
    activePage: state.perspective.activePage,
    activeSubPage: state.perspective.activeSubPage,
    viewLinks: state.perspective.viewLinks,
    enabledPerspective: state.perspective.selected,
    confdefns: state.appConfig.confDefns,
    mfpScopeId: getScopeId(state.mfpScope),
    isFetchingMfpScope,
    isNewScope,
    redirectOnScopeExpired: state.perspective.redirectOnScopeExpired,
  };
}

function mapDispatchToProps(dispatch: AppThunkDispatch): DispatchProps {
  return {
    updateAppConfig(tenantConfig: any) {
      dispatch(updateAppConfig(tenantConfig));
    },
    setActivePerspective(perspective: BoundEnabledPerspective, tab?: string) {
      // mfp scope information is configured per-tab, so the tab needs to be defined when
      // the perspective is assigned, otherwise we can't fetch the mfp scope information,
      // so, if we know it here, set it before assigning the perspective
      if (tab && !isEmpty(tab)) {
        dispatch(setActiveTab(tab));
      }
      dispatch(setActivePerspective(perspective));
      const perspectiveLookupKey = getPerspectiveLookupKey(perspective);
      setSessionPerspective(perspectiveLookupKey as Perspective);
    },
    setActivePage(data: string) {
      dispatch(preSetActivePage());
      dispatch(setActivePageAndComponentProps(data));
      if (data !== '/') setSessionPage(data);
    },
    setActiveSubPage(data: string | undefined) {
      dispatch(preSetActiveSubPage());
      dispatch(setActiveSubPage(data));
      setSessionSubPage(data);
    },
    setActiveTab(tab: string) {
      dispatch(setActiveTab(tab));
      setSessionTab(tab);
    },
    setViewLinks(links: RouteLink[]) {
      dispatch(setViewLinks(links));
    },
    getMfpScope: async (request: MfpGetScopeRequest) => {
      const req = await dispatch(getScope(request));
      return req.type;
    },
    clearMfpScope: () => dispatch(clearScope()),
    onMainMount: () => {
      dispatch(appReady());
    },
    clearScopeRedirect: () => dispatch(setRedirectOnScopeExpired(null)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(makePrintSensitive(withRouter(NavigationShell())));
